import * as ActionTypes from './ActionTypes';
import LogsApi from '../../api/LogsApi';
import ILogPage from '../../shared/interfaces/ILog';

function listSuccess(results: ILogPage) {
    return { type: ActionTypes.LIST_LOGS_SUCCESS, result: results };
}

function listFailed(result: string) {
    return { type: ActionTypes.LIST_LOGS_FAILURE, result: result };
}

export function list(id: number, type: string, page?: number, pageSize?: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        LogsApi.getLogs(id, type, page, pageSize)
            .then((result: ILogPage) => {
                dispatch(listSuccess(result));
            })
            .catch((error: string) => {
                dispatch(listFailed(error));
                throw error;
            });
}
